import { render, staticRenderFns } from "./customContentEditor.vue?vue&type=template&id=362df2c4&scoped=true"
import script from "./customContentEditor.vue?vue&type=script&lang=js"
export * from "./customContentEditor.vue?vue&type=script&lang=js"
import style0 from "./customContentEditor.vue?vue&type=style&index=0&id=362df2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362df2c4",
  null
  
)

export default component.exports